/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Passkey_SignupInputs */



/**
* | output |
* | --- |
* | "Create Account with Passkey" |
*
* @param {Login_Passkey_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_passkey_signup = /** @type {((inputs?: Login_Passkey_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Passkey_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un compte avec Passkey")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear cuenta con Passkey")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar Conta com Passkey")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea Account con Passkey")
	return /** @type {LocalizedString} */ ("Create Account with Passkey")
});